import { Data } from './DATA';
export const OptionalDataKeys = [Data.OptionalPhoneNumber];